import { useEffect, useState } from "react";
import { History as HistoryIcon, Timer as TimerIcon } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { fmtDate, fmtDur, fmtTime } from "@/lib/format";
import { Empty, Pill } from "@/components/Common";
import { Skeleton } from "@/components/ui/skeleton";

export default function History() {
  const { activeProfile } = useAuth();
  const [d, setD] = useState(null);
  useEffect(() => {
    if (activeProfile) api.get("/me/history", { params: { profile_id: activeProfile.id } }).then((r) => setD(r.data));
  }, [activeProfile]);
  if (!d) return <Skeleton className="h-40 rounded-2xl" />;
  return (
    <div className="space-y-5">
      <h1 className="text-3xl font-extrabold tracking-tight text-[#1A3323] rise">Riwayat Climbing</h1>
      <div className="grid grid-cols-3 gap-2 rise rise-1">
        {[["Rotasi selesai", d.total_completed, "history-total"], ["Event hadir", d.events_attended, "history-events"], ["Rata-rata", fmtDur(d.avg_duration_seconds), "history-avg"]].map(([l, v, id]) => (
          <div key={l} className="rounded-2xl bg-[#1A3323] p-3 text-[#FDFCF8]">
            <div className="text-[11px] text-[#FDFCF8]/60">{l}</div>
            <div className="font-mono text-xl font-extrabold" data-testid={id}>{v}</div>
          </div>
        ))}
      </div>
      {d.items.length === 0 ? (
        <Empty icon={HistoryIcon} title="Belum ada climbing selesai" desc="Rotasi yang dikonfirmasi selesai oleh keeper akan muncul di sini." />
      ) : (
        <div className="space-y-2">
          {d.items.map((i) => (
            <div key={i.id} className="rounded-2xl bg-white p-4 ring-1 ring-[#1A3323]/10" data-testid="history-item">
              <div className="flex items-center justify-between">
                <div className="font-mono text-lg font-extrabold text-[#1A3323]">{i.number}</div>
                <div className="text-xs text-muted-foreground">{fmtDate(i.date)}</div>
              </div>
              <div className="text-sm font-semibold">{i.event_name} · {i.route_name}</div>
              <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-muted-foreground">
                <span>{fmtTime(i.started_at)} – {fmtTime(i.completed_at)}</span>
                <Pill className="bg-[#EDE9DC] text-[#1A3323]"><TimerIcon className="mr-1 h-3 w-3" />{fmtDur(i.duration_seconds)}</Pill>
                {i.was_overdue && <Pill className="bg-red-100 text-red-800">&gt; standar</Pill>}
                <Pill className="bg-green-100 text-green-900">Selesai</Pill>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
